import { workflowIdEndpoint } from "../../utils/api/urls";
import { useApi } from "../../utils/api/useApi";
import { useToastNotification } from "../useToastNotification/useToastNotification";

export const useWorkflowIdWithNotification = () => {
  const { get } = useApi<{ workflowId: string }>();
  const { showNotification } = useToastNotification();

  const getWorkflowIdSafely = async (): Promise<string | null> => {
    try {
      const response = await get(workflowIdEndpoint);
      return response.workflowId;
    } catch (err: any) {
      showNotification(err?.message || "Error getting workflow ID", "error");
      return null;
    }
  };

  return { getWorkflowIdSafely };
};
